import React, {useContext, useEffect, useState} from 'react';
import {Card, CardBody, CardHeader, Col, Container, ListGroup, Row} from 'reactstrap';
import {Breadcrumbs, H6} from '../../../../AbstractElements';
import {useParams} from "react-router";
import axiosConfig from "../../../../Config/axios";
import Loader from "../../../../Layout/Loader";
import {BootstrapTabContainer, BootstrapTabContent} from "../../../../CommonElements/BootstrapTabs";
import RoleForm from "../Component/Form";
import RolePermissionListView from "../../Permission/Component/RolePermissionListView";
import {ActivityLog} from "../../../SystemCore/ActivityLog";
import ButtonIcon from "../../../../CommonElements/ButtonIcon";
import {getPrivilegeRoute} from "../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../_helper/Authorization";
import type {Role} from "../Types/RoleTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

const RoleShow = () => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [role, setRole] = useState<Role | null>(null);
    const params = useParams();
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    useEffect(() => {
        setLoaderVisibility(true);
        const config = {};
        axiosConfig
            .get(`/privilege/role/${params.role}`, config)
            .then((response: { data: { data: Role; }; }) => {
                if (response?.data?.data) {
                    setRole(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }, [params.role]);

    return (
        <div>
            <Breadcrumbs mainTitle="Roles" parent="Privilege" subParentLink={getPrivilegeRoute('role')}
                         subParent={'Roles'} title={role?.name}/>
            <Container fluid={true}>
                <div className="user-profile">
                    <Loader visibility={loaderVisibility}/>
                    <Row>
                        <Col sm='12' lg='3'>
                            <Card className='hovercard text-center'>
                                <CardHeader className='social-profile'>
                                </CardHeader>
                                <div className='info'>
                                    <Row className='step3' data-intro='This is the your details'>
                                        <Col sm='12' lg='12' className='order-sm-0 order-xl-1'>
                                            <div className='user-designation'>
                                                <div className='title'>
                                                    <a>
                                                        {role?.display_name}
                                                    </a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='6' lg='12' className='order-sm-1 order-xl-0'>
                                            <Row>
                                                <Col>
                                                    <div className='ttl-info text-center'>
                                                        <H6>
                                                            {role?.name}
                                                        </H6>
                                                        <H6>
                                                            {role?.description}
                                                        </H6>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody>
                                    <div className='social-network theme-form'>
                                        <span className='f-w-600 text-danger'>Danger Zone</span>
                                        {!role?.system_defined && <ButtonIcon attrBtn={{
                                            onClick: RoleShow
                                        }} type={'delete'} permission={'delete-role'}/>}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm='12' lg='9'>
                            <Card className='hovercard'>
                                <CardBody>
                                    <BootstrapTabContainer>
                                        <BootstrapTabContent title={'Dashboard'}
                                                             icon={'icofont icofont-dashboard'}>
                                            This is Dashboard
                                        </BootstrapTabContent>
                                        <BootstrapTabContent title={'Users'} icon={'icofont icofont-ui-user'}>
                                            <ListGroup>
                                                <Row>
                                                    {role?.users?.map((user, key) => (
                                                        <Col sm="4" key={key}>
                                                            <Card>
                                                                <CardBody style={{height: '150px'}}
                                                                          className="shadow-lg p-25 shadow-showcase align-items-center text-center">
                                                                    <h6>
                                                                        {user.name}
                                                                    </h6>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </ListGroup>
                                        </BootstrapTabContent>
                                        <BootstrapTabContent title={'Permissions'} icon={'icofont icofont-key'}>
                                            <RolePermissionListView roleID={role?.id}/>
                                        </BootstrapTabContent>
                                        <BootstrapTabContent title={'Activity Log'} icon={'icofont icofont-list'}>
                                            {role && <ActivityLog subjectType="role" subjectId={role.id}/>}
                                        </BootstrapTabContent>
                                        <BootstrapTabContent title={'Update'} icon={'icofont icofont-ui-edit'}>
                                            <Row className={'justify-content-center'}>
                                                <Col md={6}>
                                                    <RoleForm role={role} callBack={(role) => {
                                                        setRole(role)
                                                    }}/>
                                                </Col>
                                            </Row>
                                        </BootstrapTabContent>
                                    </BootstrapTabContainer>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default RoleShow;
